var exports = {
  "zr": "ScreenShareBufferingFrame.module__root___ZVU3WD",
  "WO": "ScreenShareBufferingFrame.module__corner___ZVU3WD",
  "u1": "ScreenShareBufferingFrame.module__spinner___ZVU3WD",
  "MI": "ScreenShareBufferingFrame.module__failureContent___ZVU3WD",
  "nV": "ScreenShareBufferingFrame.module__failureTitle___ZVU3WD",
  "eB": "ScreenShareBufferingFrame.module__failureSubtext___ZVU3WD",
  "sM": "ScreenShareBufferingFrame.module__srOnly___ZVU3WD",
  "Om": "ScreenShareBufferingFrame.module__dot___ZVU3WD",
  "wV": "ScreenShareBufferingFrame.module__dot0___ZVU3WD",
  "TQ": "ScreenShareBufferingFrame.module__dot1___ZVU3WD",
  "Mc": "ScreenShareBufferingFrame.module__dot2___ZVU3WD",
  "FA": "ScreenShareBufferingFrame.module__dot3___ZVU3WD",
  "yY": "ScreenShareBufferingFrame.module__dot4___ZVU3WD",
  "Ff": "ScreenShareBufferingFrame.module__dot5___ZVU3WD",
  "Mi": "ScreenShareBufferingFrame.module__dot6___ZVU3WD",
  "FG": "ScreenShareBufferingFrame.module__dot7___ZVU3WD",
  "MZ": "ScreenShareBufferingFrame.module__dot8___ZVU3WD",
};

module.exports = exports;
